/**
 * Geschenkauswahl: fügt Schere + gewähltes Geschenk gemeinsam zum Warenkorb hinzu,
 * verknüpft über die Line-Item-Property `_gift_for_variant_id`.
 *
 * Erwartet die Struktur aus snippets/geschenk-auswahl.liquid innerhalb eines
 * Formulars mit action="/cart/add" (Standard-Produktformular).
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-geschenk-auswahl]').forEach((wrapper) => {
    const form = wrapper.closest('form[action*="/cart/add"]');
    if (!form) {
      console.warn('geschenk-auswahl: kein umschließendes Warenkorb-Formular gefunden.');
      return;
    }

    form.addEventListener('submit', (event) => {
      const selected = wrapper.querySelector('input[name="geschenk_variant_id"]:checked');

      if (!selected) {
        // Pflichtauswahl: ohne Geschenkauswahl kein Absenden.
        // (Falls die Auswahl optional sein soll: diesen Block entfernen/anpassen —
        // siehe offene Frage im Briefing.)
        event.preventDefault();
        window.alert('Bitte wähle dein Geschenk aus, bevor du fortfährst.');
        return;
      }

      event.preventDefault();
      addScissorAndGiftToCart(form, wrapper, selected.value);
    });
  });

  /**
   * @param {HTMLFormElement} form
   * @param {HTMLElement} wrapper
   * @param {string} giftVariantId
   */
  async function addScissorAndGiftToCart(form, wrapper, giftVariantId) {
    const scissorVariantId = wrapper.dataset.scissorVariantId;
    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    try {
      // 1. Schere über das Standard-Formular hinzufügen
      const formData = new FormData(form);
      const addScissorResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      if (!addScissorResponse.ok) {
        throw new Error('Schere konnte nicht zum Warenkorb hinzugefügt werden.');
      }

      // 2. Gewähltes Geschenk hinzufügen, verknüpft über eine Line-Item-Property.
      //    Diese Property wird von der Shopify Function (run.js) ausgelesen, um zu
      //    prüfen, ob das Geschenk zur gekauften Schere gehört.
      const addGiftResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: giftVariantId,
              quantity: 1,
              properties: {
                _gift_for_variant_id: scissorVariantId,
              },
            },
          ],
        }),
      });

      if (!addGiftResponse.ok) {
        throw new Error('Geschenk konnte nicht zum Warenkorb hinzugefügt werden.');
      }

      window.location.href = window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart`
        : '/cart';
    } catch (error) {
      console.error('geschenk-auswahl:', error);
      window.alert(
        'Beim Hinzufügen von Schere und Geschenk zum Warenkorb ist ein Fehler aufgetreten. Bitte versuche es erneut.'
      );
      if (submitButton) submitButton.disabled = false;
    }
  }
});